import { render, staticRenderFns } from "./coursewareData.vue?vue&type=template&id=74060442&scoped=true&"
import script from "./coursewareData.vue?vue&type=script&lang=js&"
export * from "./coursewareData.vue?vue&type=script&lang=js&"
import style0 from "./coursewareData.vue?vue&type=style&index=0&id=74060442&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74060442",
  null
  
)

export default component.exports